import { useCallback } from 'react';

interface UseTiptapDragDropProps {
  onDragEnter?: (event: DragEvent) => void;
  onDragLeave?: (event: DragEvent) => void;
  onDrop?: (event: DragEvent) => void;
}

export function useTiptapDragDrop({ onDragEnter, onDragLeave, onDrop }: UseTiptapDragDropProps) {
  const handleDragEnter = useCallback(
    (event: React.DragEvent) => {
      event.preventDefault();
      onDragEnter?.(event.nativeEvent as DragEvent);
    },
    [onDragEnter],
  );

  const handleDragLeave = useCallback(
    (event: React.DragEvent) => {
      event.preventDefault();
      onDragLeave?.(event.nativeEvent as DragEvent);
    },
    [onDragLeave],
  );

  const handleDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (event: React.DragEvent) => {
      event.preventDefault();
      onDrop?.(event.nativeEvent as DragEvent);
    },
    [onDrop],
  );

  return {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
  };
}
